<template>
    <section id="Flagship" class="contain">

        <div class="top">
            <div class="title">Every Year at our Flagship Conferences</div>
        </div>
        <div class="timeline-slider">
            <div class="swiper" ref="timelineSlider" id="timeline-slider">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="timeline-slider-box">
                            <div class="year">2023</div>
                            <ul>
                                <li class="down">
                                    <div class="event">
                                        <div class="title">OUTPLAYING CHALLENGES</div>
                                        <div class="description">
                                            <p>The world's largest and most highly anticipated frontier and
                                                emerging markets investment conference to date, welcomed 1120
                                                registered attendees including over 561 institutional investors
                                                and fund managers, representing 247 international financial
                                                institutions and 179 companies in numerous key sectors across 29
                                                countries. The event hosted over 12,000 meetings between
                                                investors and C-suite level management from listed companies.
                                                Over the course of the conference, attendees delved into the key
                                                themes and strategies that are shaping investment decisions
                                                across frontier and emerging markets.</p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>
                                <li class="up">
                                    <div class="event">
                                        <div class="title">WEATHERING INFLATION - FINDING FOCUS IN FEM</div>
                                        <div class="description">
                                            <p>The 16th One-on-One Conference marked the first in-person
                                                iteration since the outbreak of COVID-19 and accordingly your
                                                presence really mattered. The event, once again the world's
                                                largest and most highly anticipated frontier emerging markets
                                                investment conference to date, welcomed over 650 investors from
                                                over 270 institutions. We also hosted more than 13,000 meetings
                                                between investors and C-suite level management from 205 leading
                                                listed companies spanning 33 countries. Over the course of the
                                                conference, attendees delved into the key themes and strategies
                                                that are shaping investment decisions across frontier emerging
                                                markets</p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="timeline-slider-box">
                            <div class="year">2023</div>
                            <ul>
                                <li class="up">
                                    <div class="event">
                                        <div class="title">AFTER REFLATION</div>
                                        <div class="description">
                                            <p>As 2021 drew to a close, the conference came as investors in FEM
                                                markets were taking stock of both global developments and local
                                                growth stories. FM and MENA players outperformed EM indices
                                                during the year, thanks to a combination of rising retail
                                                activity and strong foreign inflows into MENA markets even when
                                                aggregate valuations were no longer cheap. The conference
                                                brought together investors and key market participants to share
                                                insights on: what the recovery looks like for 2022, the future
                                                of inflation in the US and FEM economies, the potential for a
                                                commodity super cycle, the ongoing burden of high debt levels,
                                                and the staying power of high-growth stocks.</p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>
                                <li class="down">
                                    <div class="event">
                                        <div class="title">FEMS REGAINING MOMENTUM</div>
                                        <div class="description">
                                            <p>The conference in March came as emerging markets were slated to
                                                become key beneficiaries of the economic pickup seen toward the
                                                end of 2020. As a result, investors and asset managers assessed
                                                risk appetites and looked to give frontier market assets larger
                                                allocations of their portfolios. A weaker dollar and higher
                                                equity valuations in other markets served to accelerate appetite
                                                for frontier emerging stocks. The expectation was that global
                                                trade tensions would begin to ease, and that subsequent FDI
                                                inflows back into these markets would increase currency values
                                                and slash interest rates. The rollout of vaccination programs
                                                around the globe also increased risk appetite for investors,
                                                reversing over USD 90 billion in outflows from emerging market
                                                equities since the start of COVID-19 lockdowns in March of 2020.
                                            </p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="timeline-slider-box">
                            <div class="year">2023</div>
                            <ul>
                                <li class="up">
                                    <div class="event">
                                        <div class="title">A YEAR OF CHANGE: ADJUSTING TO NEW NORMS</div>
                                        <div class="description">
                                            <p>The months leading up to the conference imposed many challenges
                                                on businesses across FEMs. From supply chain disruptions to
                                                restrictions on mobility, the pandemic radically altered the
                                                operating environment for manufacturers and service providers
                                                alike. During the last few months of 2020, investors looked to
                                                EFG Hermes for insights on the way forward for FEMs. With equity
                                                and debt flows exhibiting a strong recovery for EMs, investor
                                                appetite for the region continued despite bearish outlooks on
                                                global economic growth. As the globe inched toward reopening,
                                                participants began to wonder if FEM and MENA central banks have
                                                the firepower to mitigate the impacts of the virus, whether
                                                inflation is expected to see an uptick, and if they're braced
                                                for potential second or third waves.</p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>
                                <li class="down">
                                    <div class="event">
                                        <div class="title">THE EFG HERMES VIRTUAL INVESTOR CONFERENCE</div>
                                        <div class="description">
                                            <p>The June 2020 conference came as the end of another unprecedented
                                                year was ending, investors readjusted their lenses to focus on
                                                the path forward and look to us for forward looking insights
                                                through the turbulence brought on by the covid-19 pandemic.
                                                Vaccine optimism kept investors bullish on emerging market
                                                stocks, with prospects of a vaccine breakthrough increasing risk
                                                appetite and reversing the more than USD 90 billon outflows from
                                                EM equities at the outset of COVID-19 lockdowns in March 2020.
                                                Moreover, EM stocks were expected to outperform stocks elsewhere
                                                in the second quarter of 2021 as a global economic rebound was
                                                expected on the back of the roll out of covid-19 vaccines.</p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="timeline-slider-box">
                            <div class="year">2023</div>
                            <ul>
                                <li class="up">
                                    <div class="event">
                                        <div class="title">NAVIGATING THE PATH TO OPPORTUNITIES</div>
                                        <div class="description">
                                            <p>The 2019 conference came after yet another challenging year for
                                                Emerging and Frontier Markets. In spite of improved valuations
                                                following weak performance in 2018, increased in US interest
                                                rates continued to pose a challenge for heavily indebted FEM
                                                markets. Stimulus measures offered diminishing returns to scale
                                                for the Chinese economy, regarded as an increasingly important
                                                engine for FEM growth. The year saw two strong themes throughout
                                                FEM - (1) index upgrades and the impact of passive flows on
                                                Saudi Arabia and often-overlooked Kuwait and (2) ongoing
                                                recovery in markets that have already taken steps to rebalance
                                                their economies, such as Egypt and Pakistan.</p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>
                                <li class="down">
                                    <div class="event">
                                        <div class="title">SHIFTING BENCHMARKS: FRONTIER EMERGING MARKETS</div>
                                        <div class="description">
                                            <p>The 2018 conference came on the heels of strong economic growth,
                                                favorable demographics, a growing consumer-driven middle class
                                                and advancing reform agendas enabling MENA and frontier emerging
                                                markets to gain considerable traction among investors in 2017,
                                                with year-to-date fund inflows at record highs in multiple
                                                geographies. Shifting dynamics for oil and the USD, weaker
                                                commodity prices and a pivot in Chinese-led growth and several
                                                regional policy reforms and political turbulences were among the
                                                key themes of discussed in 2018. The conference provided
                                                unmatched access and insights to investors and fund managers
                                                seeking to explore the region's shifting benchmarks and identify
                                                investment plays.</p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="timeline-slider-box">
                            <div class="year">2023</div>
                            <ul>
                                <li class="up">
                                    <div class="event">
                                        <div class="title">THE PULSE OF MENA & FRONTIER MARKETS</div>
                                        <div class="description">
                                            <p>The 2017 conference came in a challenging year for emerging and
                                                frontier markets. With Brexit and the election of Donald Trump
                                                resulting in the rising risk of protectionism to EM growth, as
                                                well as the rising dollar and US bond yields, EM have relied on
                                                their own internal factors, such as economic reform and
                                                attractive demographic dynamics, to retain their growth
                                                trajectories and attract FDI. Amid conflicting signals about the
                                                global outlook and investment prospects, it was a key setting
                                                for equity investors to meet face-to-face with regional
                                                high-level executives and industry professionals in a custom
                                                backdrop designed for open dialogue and the exploration of
                                                compelling investment opportunities.</p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>
                                <li class="down">
                                    <div class="event">
                                        <div class="title">MENA: OPPORTUNITIES BEYOND OIL</div>
                                        <div class="description">
                                            <p>The 2016 conference shaped up to be a particularly crucial
                                                meeting as we witnessed major global changes that had
                                                significant repercussions on the investment climate in the
                                                region. As the year 2015 drew to a close, we saw the continued
                                                rollout of new political and economic realities across the
                                                region, with new challenges bringing new opportunities. In
                                                Egypt, a new Central Bank of Egypt governor had just taken the
                                                helm and natural gas flows to industry improved substantially.
                                                Meanwhile, the outlook for the UAE and Kuwait was broadly
                                                positive, with the UAE's diverse economy and Kuwait's financial
                                                reserves helping both economies withstand the impact of lower
                                                oil prices. The EFG Hermes' One on One Conference provided
                                                companies and investors with the perfect venue to discuss these
                                                new regional realities and explore compelling opportunities that
                                                went beyond oil and tapped into the core fundamentals of
                                                regional economies.</p>
                                            <a>Read More</a>
                                        </div>
                                        <b class="date">September 2023</b>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<!-- Swiper JS -->
<script>
import $ from 'jquery';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default {
    data() {
        return {
            timeLineHeight: 560,
            timelineSlider: this.$refs.timelineSlider
        }
    },
    mounted(){
        let timeLineHeight = document.getElementById("timeline-slider").offsetHeight;
		document.getElementById("timeline-slider").style.height = `${timeLineHeight}px`;

		$(".timeline-slider-box ul li .event .description a").on("click", function () {
			if ($(this).parents(".description").hasClass("free")) {
				$(this).parents(".description").removeClass("free");
				$(this).text("Read More");
				$("#timeline-slider").height(timeLineHeight)
			}
			else {
				$(".description").removeClass("free");
				$(this).parents(".description").addClass("free");
				$(".timeline-slider-box ul li .event .description a").text("Read More");
				$(this).text("Read less");
				$("#timeline-slider").height(timeLineHeight + ($(this).parents(".event").height() - 135))
			}

			console.log($(this).parents("li").hasClass("up"));
			if ($(this).parents("li").hasClass("up")) {
				$("#timeline-slider").addClass("end");
			} else {
				$("#timeline-slider").removeClass("end");
			}
		})

		this.swiper = new Swiper('#timeline-slider', {
			breakpoints: {
				2400: {
					slidesPerView: 3.5,
				},
				2200: {
					slidesPerView: 3,
				},
				2000: {
					slidesPerView: 2.8,
				},
				1800: {
					slidesPerView: 2.5,
				},
				1600: {
					slidesPerView: 2.2,
				},
				1500: {
					slidesPerView: 2,
				},
				1400: {
					slidesPerView: 1.8,
				},
				1100: {
					slidesPerView: 1.5,
				},
				700: {
					slidesPerView: 1.2,
				},
				600: {
					slidesPerView: 1,
				},
			},
			spaceBetween: 0,
			autoHeight: true,
			freeMode: true,
		});
    },
    beforeDestroy() {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }
}
</script>
